<template>
  <div>
    <template v-if="lager.length > 0">
      <template v-if="totalQuantity > 0">
        <div v-for="la in lager">
          <template v-if="la.warehouseId === 1 && la.quantity > 0">
            <div class="mb-2 text-center" :class="'availability-'+currentVariation.variation.availability.id">
              <template v-if="lager.length == 2">
                {{ la.quantity }} {{ currentVariation.unit.names.name }} -
              </template>
               {{ currentVariation.variation.availability.names.name }}
            </div>
          </template>
          <template v-if="la.warehouseId === 119 && la.quantity > 0">
            <div class="mb-2 text-center availability-4">
              {{ la.quantity }} {{ currentVariation.unit.names.name }} - {{ propText }}
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="mb-2 text-center" :class="'availability-'+currentVariation.variation.availability.id">
          {{ $translate("Woerner::Template.notCurrentlyInWarehouse") }}
          <br>
          {{ $translate("Woerner::Template.unknownDeliveryDate") }}
        </div>
      </template>
    </template>
    <template v-else>
      <div class="mb-2 text-center" :class="'availability-'+currentVariation.variation.availability.id">
        {{ currentVariation.variation.availability.names.name }}
        <template v-if="zulauf">
          <br>
          {{ zulauf }}
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default
{
  name: "zulauf",
  data()
  {
    return {
      lager:[]
    };
  },
  props:
      {
        firstLager:
            {
              type: Array,
              default: []
            }
      },
  inject: {
    itemId: {
      default: null
    }
  },
  created()
  {
    this.lager = this.firstLager
  },
  watch: {
    currentVariation: {
      handler() {
        this.getWarehouses();
      },
    }
  },
  methods:{
    getWarehouses(){
      let _self = this;
      $.ajax({
        type: 'GET',
        url: `/item/getWarehouse/${this.currentVariation.variation.id}/`,
        success: (response) => {

      /*    console.log('getWarehouses',response)*/
          if (response) {
            this.lager = response
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error("Error fetching reviews:", textStatus, errorThrown);
        }
      });
    },
  },
  computed:
      {
        totalQuantity()
        {
          let total = 0;
          for(let i = 0; i < this.lager.length; i++)
          {
            total = parseInt(total) + parseInt(this.lager[i].quantity);
          }
          return total;
        },
        currentVariation() {
          return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },
        propText()
        {
          let current               = this.currentVariation;
          let textFromProp          = '';
          if(current.hasOwnProperty('variationProperties')  && current.variationProperties.length > 0)
          {
            for(let i = 0; i < current.variationProperties.length; i++)
            {
              if(current.variationProperties[i].id === 6)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  if(current.variationProperties[i].properties[i2].id === 448)
                  {
                    textFromProp = current.variationProperties[i].properties[i2].values.value;
                  }
                }
              }
            }
          }
          return textFromProp;
        },
        zulauf()
        {
          let current               = this.currentVariation;
          let availability          = parseInt(current.variation.availabilityId);
          let foundTags             = false;
          let textFromProp          = ''
          let estimatedAvailableAt  = current.variation.estimatedAvailableAt ?? '';

          if(current.hasOwnProperty('tags')  && current.tags.length > 0)
          {
            for(let i = 0; i < current.tags.length; i++)
            {
              if(current.tags[i].id === 218 || current.tags[i].id === 220)
              {
                foundTags = true;
              }
            }
          }

          if(current.hasOwnProperty('variationProperties')  && current.variationProperties.length > 0)
          {
            for(let i = 0; i < current.variationProperties.length; i++)
            {
              if(current.variationProperties[i].id === 6)
              {
                for(let i2 = 0; i2 < current.variationProperties[i].properties.length; i2++)
                {
                  if(current.variationProperties[i].properties[i2].id === 448)
                  {
                    textFromProp = current.variationProperties[i].properties[i2].values.value;
                  }
                }
              }
            }
          }
          if(availability === 9 && foundTags)
          {
            if(textFromProp !=='')
            {
              return textFromProp;
            }
            else
            {
              return this.$translate("Woerner::Template.deliveryDate");
            }
          }
          if(availability === 9 && foundTags === false)
          {
            if(estimatedAvailableAt !== '')
            {
              let MyDate = new Date(estimatedAvailableAt);
              MyDate.setDate(MyDate.getDate() + 5);

              let deliveryDate = ('0' + MyDate.getDate()).slice(-2)  + '.' + ('0' + (MyDate.getMonth()+1)).slice(-2) + '.' + MyDate.getFullYear();

              let formatet     = this.$translate("Woerner::Template.deliveryDateValue", {"date":deliveryDate});
              return formatet
            }
            else if (textFromProp !== '')
            {
              return textFromProp;
            }
            else
            {
              return this.$translate("Woerner::Template.deliveryDate");
            }
          }
        }
      }
}
</script>